var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasNoLink)?_c('span',[_vm._t("default")],2):_c('NuxtLink',_vm._b({},'NuxtLink',_vm.nuxtLinkProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }